module.exports = __webpack_public_path__ + "static/media/ThebanArcher.f91f6a38.jpg";